import React from "react";
import { Row, Col, Tabs } from "antd";
import "./style.css";

export default function Tab(props) {
  const { TabPane } = Tabs;

  return (
    <Tabs defaultActiveKey="1" onChange={props.onChangeTab}>
      {(props.plantData || []).map((item, i) => {
        return (
          <TabPane tab={item.key} key={i + 1}>
            {item?.component()}
          </TabPane>
        );
      })}
    </Tabs>
  );
}
